import { render, staticRenderFns } from "./165.vue?vue&type=template&id=505ee506&scoped=true&"
var script = {}
import style0 from "./165.vue?vue&type=style&index=0&id=505ee506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ee506",
  null
  
)

export default component.exports